exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2pM09 {\n  padding-left: 20px;\n  padding-right: 20px;\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_2pM09"
};